/*
    Imports the Cockpit API URL from the config.
*/
import { API_CONFIG } from '../config.js';

export default {
	/* GET /api/v1/playlists */
	getPlaylists: function () {
		return axios.get(API_CONFIG.API_URL + '/playlists');
	},

	/* GET	/api/v1/playlist/{playlistID} */
	getPlaylist: function (playlistID) {
		return axios.get(API_CONFIG.API_URL + '/playlists/' + playlistID);
	},

	/* POST	/api/v1/playlists */
	postAddNewPlaylist: function (title, description, userUUID, projectID, password) {
		return axios.post(API_CONFIG.API_URL + '/playlists', {
			title: title,
			description: description,
			userUUID: userUUID,
			projectID: projectID,
			password: password
		});
	},

	/* PUT 	/api/v1/playlist/{id} */
	putEditPlaylist: function (data) {
		return axios.put(API_CONFIG.API_URL + '/playlists/' + data.hash_id, data);
	},

	/* DELETE	/api/v1/playlist/{playlistID} */
	deletePlaylist: function (playlistID) {
		return axios.delete(API_CONFIG.API_URL + '/playlists/' + playlistID);
	}
};
